// src/pages/ImpressumPage.jsx
import React from "react";
import { Typography, Link, Paper } from "@mui/material";

export default function ImpressumPage() {
    return (
        <Paper sx={{ p: 4, borderRadius: 2 }}>
            <Typography variant="h4" sx={{ mb: 3, fontWeight: 700 }}>
                Impressum
            </Typography>

            <Typography variant="h6" sx={{ mt: 2, fontWeight: 700 }}>
                Anbieter
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Tourismusinfo GmbH<br />
                Hüttenweg 16<br />
                CH-8254 Basadingen<br /><br />
                Telefon: +41 (0)52 654 18 12<br />
                Telefax: +41 (0)52 654 18 09<br />
                E-Mail:{" "}
                <Link href="mailto:info@speiserestaurant.ch" underline="hover">
                    info@speiserestaurant.ch
                </Link>
                <br />
                Internet:{" "}
                <Link href="http://speiserestaurant.ch" underline="hover">
                    http://speiserestaurant.ch
                </Link>
                <br />
                UID-Nr.: CHE-112.030.126
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Geschäftsführung
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Markus Remesch
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Handelsregister
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Registernummer: HR CH-440.4.014.661-4
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Technische Umsetzung
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                <Link href="https://felix-hohlwegler.de" underline="hover">
                    Felix Hohlwegler Webdesign & Webentwicklung
                </Link>
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Datenschutz
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Datenschutzerklärung
            </Typography>

            <Typography variant="h5" sx={{ mt: 4, mb: 2, fontWeight: 700 }}>
                Copyright- und Nutzungsbestimmungen
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Durch die Nutzung unserer Webseiten erklären Sie sich ohne Einschränkung
                und Vorbehalt mit den hier formulierten Copyright- und
                Nutzungsbestimmungen einverstanden.
                <br /><br />
                Copyright 2015 Tourismusinfo GmbH, Basadingen. Alle Rechte vorbehalten.
                Der gesamte Inhalt der Webseiten von speiserestaurant.ch ist
                urheberrechtlich geschützt. Alle Rechte gehören Tourismusinfo GmbH oder
                Dritten. Die Inhalte der Webseiten von Tourismusinfo GmbH sind nur für
                den persönlichen und nicht-kommerziellen Gebrauch bestimmt und dürfen
                ohne vorherige schriftliche Genehmigung von Tourismusinfo GmbH weder
                vervielfältigt, übertragen oder in einem Netzwerk verfügbar gemacht
                werden.
                <br /><br />
                Warenzeichen, Logos und Dienstleistungsmarken auf speiserestaurant.ch
                sind geschützt. Es besteht kein Recht zur Nutzung ohne vorherige
                schriftliche Erlaubnis des Rechteinhabers.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Bildrechte
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Eine Vervielfältigung oder Verwendung der Bilder ist ohne ausdrückliche
                Einwilligung von Tourismusinfo GmbH nicht gestattet. Anfragen richten Sie
                bitte an die Geschäftsleitung von Tourismusinfo GmbH.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Keine Gewährleistung
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Alle Inhalte wurden sorgfältig geprüft, dennoch wird keine Gewähr für
                Verfügbarkeit, Vollständigkeit, Richtigkeit oder Aktualität übernommen.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Haftungsausschluss
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Tourismusinfo GmbH lehnt jede Haftung für direkte, indirekte und
                Folgeschäden ab. Ebenso wird keine Verantwortung für Inhalte externer
                Links übernommen.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Inserate
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Inserate und Publikationen dürfen ohne Genehmigung nicht kopiert,
                bearbeitet oder verwertet werden. Jeder Verstoß wird rechtlich verfolgt.
            </Typography>

            <Typography variant="h6" sx={{ mt: 3, fontWeight: 700 }}>
                Gerichtsstand
            </Typography>
            <Typography variant="body1" sx={{ lineHeight: 1.7 }}>
                Es gilt ausschließlich schweizerisches Recht. Gerichtsstand ist der Sitz
                der Tourismusinfo GmbH.
            </Typography>
        </Paper>
    );
}
